<template>
  <div class="page">
    <div class="locations-white locations-generic">
      <section>
        <div class="locations-title">Skokie Lagoons</div>
        <br>
        <!-- <strong>Season: May - October</strong> -->
        <!-- <Strong>Open Seven Days Per Week</Strong> -->
      </section>
      <section>
      <div>
          <!-- <strong>Open: Friday, May 12</strong> -->
        </div>
      </section>  
      <section>
        <div>
           <strong>Hours: </strong> <br>
         <strong>Saturday to Memorial Day:</strong> 9:00 a.m. until last rental, 7:00 p.m. <br>
         <strong>Sunday 4/26:</strong> 9:00 a.m. until last rental, 6:00 p.m. <br>
         <strong>Closed:</strong> Tuesday, Wednesday, Thursday Open seven days a week from <strong>Friday, May 29</strong>
        </div>
      </section>
      <section>
        <strong>Boat Rentals:</strong> Kayaks and Canoes
      </section>
      <!-- <section>
        <strong>Events:</strong>
          Temporarily unavailable
        </section>
      <section> -->
        <strong>Minimum age and Weight:</strong>
        3 years, 35 lbs. (may be higher
        depending on water and weather conditions)
      <br /><br />
      <a class="btn-primary btn" href="https://www.google.com/maps/dir/?api=1&destination=42.115718,-87.771366">
        <strong>Directions</strong>
      </a>
    </div>
    <div class="locations-green locations-generic">
      <call-button tel-number="847-414-5883"/>
      <br />1770 Tower Road, Winnetka
    </div>
 <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5918.981882119459!2d-87.77185952902106!3d42.1183721046002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880fc42201c2ffc9%3A0xda454924f2925764!2s1770%20Tower%20Rd%2C%20Winnetka%2C%20IL%2060093!5e0!3m2!1sen!2sus!4v1588721756274!5m2!1sen!2sus" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
  </div>
</template>

<script>
import CallButton from "../CallButton"

export default {
  name: "Skokie",
  components: {CallButton},
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.call-button {
  color: white;
}
iframe {
  max-width: 90%;
}
.page {
  background-image: url("../../assets/Lake.png");
  flex-direction: column;
  padding-left: 20px;
}
section {
  margin-bottom: 10px;
}
</style>




